import { laptopMaxXL, laptopMinXL } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { Container as ButtonContainer } from '../buttons/Button.style';
import { Label as NumberInputLabel } from '../inputs/NumberInput.style';
import { InputLabel } from '../inputs/SelectInput.style';
import { Label as TextInputLabel } from '../inputs/TextInput.style';
import { MAX_WIDTH } from '../layout/PageWrapper.style';

export const Container = styled.section`
  margin: 40px auto;
  width: 100%;
  max-width: ${MAX_WIDTH}px;

  @media (${laptopMaxXL}) {
    padding: 0;
    margin: 15px auto;
  }
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.textDark};
  font-size: 20px;
`;

export const FormBox = styled.div`
  padding: 20px;
  background-color: #efe9ff;
  border-radius: 5px;

  @media screen and (${laptopMaxXL}) {
    padding: 20px 15px;
  }
`;

export const FormWrapper = styled.div`
  display: flex;

  @media screen and (${laptopMaxXL}) {
    flex-direction: column;
  }
`;

export const FieldContainer = styled.div`
  display: flex;
  flex: 1;

  @media screen and (${laptopMaxXL}) {
    margin-right: -15px;
  }

  ${ButtonContainer} {
    max-width: 300px;
    height: 54px;
    min-height: 54px;
    margin-top: 48px;

    @media screen and (${laptopMaxXL}) {
      max-width: none;
      margin-top: 30px;
      margin-right: 15px;
      width: auto;
    }
  }

  ${NumberInputLabel}, ${TextInputLabel}, ${InputLabel} {
    text-transform: uppercase;
    font-weight: 400;
  }
`;

export const MortgagePaymentContainer = styled.div`
  display: flex;
  flex-basis: 220px;
  flex-direction: column;

  @media (${laptopMaxXL}) {
    flex-basis: 100%;
    margin-top: 15px;
  }
`;

export const MortgagePayment = styled.div`
  & > div {
    justify-content: center;
  }

  @media (${laptopMaxXL}) {
    text-align: center;

    p {
      text-align: center;
    }
  }

  @media (${laptopMinXL}) {
    margin-left: 15px;
  }
`;

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.primary};
  margin: 30px auto;
  max-width: 88%;
  font-weight: 600;
  text-align: center;
`;
